import {Toast} from 'mint-ui';
import {request} from '@/common/util/request';

let urls = {
    cardInfo: '/i/day21/api/gettraining',
    cardSign: '/i/day21/api/sign'
};

let actions = {
    getDays21CardInfoPrev: (context, dataObj) => {
        return request({
            'url': urls.cardInfo,
            'params': dataObj ? dataObj : {}
        }).then((result)=>{
            // debugger
            let data = result.data ? result.data : {};
            // data 判断
            // alert(data);
            if (data.error_code == 0) {
                context.commit('days21CardInitPrev', data.data);
            } else {
                Toast(data.error_msg || '获取课程信息失败，请稍后重试~');
            }
            return data;
        }).catch((error) => {
            // debugger
            Toast('服务器走丢了，请稍后重试啊啊啊~');
        });
    },
    days21CardSavePrev: (context, dataObj) => {
        return request({
            'url': urls.cardSign,
            'params': dataObj,
            'method': 'post'
        }).then((result)=>{
            let data = result.data ? result.data : {};
            // data 判断
            if (data.error_code == 0) {
                Toast({
                    message: '更新成功~',
                    iconClass: 'icon icon-success'
                });
                context.commit('days21CardUpdatePrev', dataObj);
            } else {
                Toast(data.error_msg || '更新用户信息失败~');
            }
            return data;
        }).catch((error) => {
            Toast('服务器走丢了，请稍后重试~');
        });
    },
    days21CardUpdatePrev: (context, dataObj) => {
        context.commit('days21CardUpdatePrev', dataObj);
    }
}
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitCardPrev/actions.js